Vue.directive('tab-inputs', {
    // When the bound element is inserted into the DOM...
    bind(el) {
        const inputs = el.querySelectorAll('input:not([type="hidden"]), select, textarea')
        const inputsArr = [...inputs];

        const excludeList = [
            'textarea'
        ]

        el.addEventListener('keypress', (event) => {
            // Enter pressed and item not in the excludeList
            if (event.keyCode === 13 && excludeList.indexOf(event.target.type) === -1) {
                event.preventDefault()
                const index = inputsArr.indexOf(event.target)

                if((index+1) !== inputs.length) {
                    const next = index + 1 
                    inputs[next].focus()
                }
                else if((index+1) === inputs.length) {
                    inputs[0].focus()
                }
            }
        })
    }
});